export class InvalidCredentialsError extends Error {
    constructor() {
        super('Unauthorized User');
        this.name = 'InvalidCredentialsError';
    }
}
